import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PRIMENG_MODULES } from '@shared/primeng';
import { GlobalSidenavService } from '../global-sidenav.service';
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { Router, RouterModule } from '@angular/router';
import { ButtonSeverity } from 'primeng/button';
import { VersionService } from '@services/version.service';
import { RegisteredMarkComponent } from '../registered-mark/registered-mark.component';

interface ItemRoute {
	label: string;
	icon: string;
	route: string;
	external?: boolean;
	severity: ButtonSeverity;
	outlined?: boolean;
}

@Component({
	selector: 'app-global-sidenav',
	templateUrl: './global-sidenav.component.html',
	styleUrls: ['./global-sidenav.component.scss'],
	imports: [
		CommonModule,
		RouterModule,
		...PRIMENG_MODULES,
		RegisteredMarkComponent,
	],
})
export class GlobalSidenavComponent {
	private readonly router = inject(Router);
	private readonly authService = inject(AuthService);
	public readonly userService = inject(UserService);
	public readonly versionService = inject(VersionService);
	public readonly globalSidenavService = inject(GlobalSidenavService);

	public routes: ItemRoute[] = [];

	constructor() {
		this.routes.push(
			{
				label: 'Inicio',
				icon: 'pi pi-home',
				route: '/home',
				severity: 'primary',
			},
			// {
			// 	label: 'Reservá tu capymesita',
			// 	icon: 'pi pi-calendar-plus',
			// 	route: 'https://turnosconqr.com/thecoffeebara?qr=57423642-3fde-4ead-8ffa-084e6a0e6557',
			// 	external: true,
			// 	severity: 'info',
			// },
			{
				label: 'Instagram',
				icon: 'pi pi-instagram',
				route: 'https://www.instagram.com/thecoffeebara/',
				external: true,
				severity: 'help',
			},
			{
				label: '¿Dónde estamos?',
				icon: 'pi pi-map-marker',
				route: 'https://maps.app.goo.gl/vypju8D6N42emrQG7',
				external: true,
				severity: 'warn',
			},
			{
				label: 'Envianos tu sugerencia',
				icon: 'pi pi-comment',
				route: 'https://forms.gle/ej4pFyVTJsZXH9R57',
				external: true,
				severity: 'danger',
				outlined: true,
			}
		);
	}

	public evalItemRoute(item: ItemRoute): void {
		if (item.external) {
			window.open(item.route, '_blank');
		} else {
			this.router.navigate([item.route]);
		}
	}

	public editProfile(): void {
		this.router.navigateByUrl('/onboarding?edit=true');
	}

	public async logout(): Promise<void> {
		await this.authService.logout();
	}
}
